<template>
  <div id="bankaccounts-clabe">
    <div class="vx-row mb-2">
      <div class="vx-col w-full mb-4 justify-items-center">
        <h2 class="mb-4">Registra una cuenta bancaria</h2>
      </div>
      <div class="vx-col sm:w-full mb-6">
        <div class="document-detail">
          <p class="black text-lg mb-2">Registra una cuenta bancaria para recibir tus pagos.</p>
          <p class="black text-lg mb-2">Asegúrate de que la cuenta esté a nombre de <strong>{{ getUserName() }}</strong>.</p>
        </div>
      </div>
      <div :class="colClass">
        <vs-input @input="(val) => (clabe = clabe.toUpperCase())" class="w-full" label="CLABE" name="clabe"
          v-validate="requiredRules" v-model.trim="clabe" :danger="hasError('clabe')" :danger-text="errorText('clabe')"
          :success="isSuccess('clabe')" icon-pack="feather" :disabled="hasBankAccount"
          :placeholder="requiredPlaceholder" />
      </div>
    </div>
    <div v-if="hasBankAccount" class="vx-row">
      <div :class="colClass">
        <vs-input @input="(val) => (clabe = clabe.toUpperCase())" class="w-full mb-4" label="Banco" name="clabe"
          v-validate="requiredRules" v-model.trim="bank_account.bank.name" :danger="hasError('clabe')"
          :danger-text="errorText('clabe')" :success="isSuccess('clabe')" icon-pack="feather" :disabled="hasBankAccount"
          :placeholder="requiredPlaceholder" />
      </div>
    </div>

    <vs-alert v-if="errorMssg" icon-pack="feather" style="height:auto" icon="icon-alert-triangle" class="mb-base w-2/3"
      color="danger">
      <span>{{ errorMssg }}</span>
    </vs-alert>

    <div class="vx-col w-full mb-4 align-center">
      <vs-button :disabled="clabe == null || clabe === ''" size="sm" color="black" @click="saveDataForm()">Registrar</vs-button>
    </div>

    <!-- <two-factor-auth :user-id="user.user_id" provider="sms"
      custom-indication-message="Por favor ingresa los 6 dígitos de tu Segundo Factor de Autenticación para ejecutar la operación."
      @on-code-validated="onAuth" /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TwoFactorAuth from "@components/2fa/TwoFactorAuth";

export default {
  name: "SupplierBusinessCLABE",
  components: {
    TwoFactorAuth,
  },
  props: ["isPersonal", "onboardingStepData"],
  data: () => ({
    bankAccounts: [],
    showTwoFactorAuth: false,
    isMounted: false,
    document: null,
    requiredRules: "required|digits:18",
    errorMssg: null,
    colClass: "vx-col sm:w-full md:w-1/3 mb-2",
    requiredPlaceholder: "(Requerido)",
    optionalPlaceholder: "(Opcional)",
    clabe: null
  }),
  async created() {
    const { data } = await axios.get('api/app/bank-account');
    this.bankAccounts = data;
    this.clabe = this.bank_account ? this.bank_account.clabe : null;

    if (this.bankAccountStatus == 'rejected') {
      this.errorMssg = "Tu cuenta ha sido rechazada. Por favor, ingresa una cuenta válida.";
    }

    this.isMounted = true;
  },

  computed: {
    ...mapState('auth', ['user']),
    bank_account() {
      return this.bankAccounts.length > 0 ? this.bankAccounts[0] : null;
    },
    hasBankAccount() {
      return this.bank_account != null && this.bankAccountStatus != 'rejected';
    },
    bankAccountStatus() {
      if (this.bank_account === null) {
        return null;
      }

      return this.bank_account.verified;
    }
  },
  methods: {
    async saveDataForm() {
      this.errorMssg = null;

      if (this.hasBankAccount) {
        this.$emit("updated", this.bank_account);
        return;

      }

      if (!(await this.validateForm())) {
        return;
      }

      this.showLoading(true, "Guardando...");

      try {
        let payload = {
          clabe: this.clabe,
          bank_account_id: this.bank_account ? this.bank_account.id : null
        };

        const res = await axios.patch('/api/app/bank-account/national', payload);

        if (res.status == 200) {
          this.successNotifDialog("¡Cuenta bancaria registrada!", "Estamos verificando tu cuenta. Te notificaremos por correo cuando tengamos respuesta.");
          this.$emit("updated");
        } else {
          this.errorMssg = res.data;
        }
        this.showLoading(false);
      } catch (e) {
        this.showLoading(false);
        console.log(e);
        if(e.response && e.response.data && e.response.data.message) {
          this.errorMssg = e.response.data.message;
        }
      } finally {
        this.showLoading(false);
        this.$emit("updated");
      }
    },
    async validateForm() {
      this.errorMssg = null;
      return this.$validator.validateAll();
    },
    hasError(val) {
      return this.errors.has(val);
    },
    errorText(val) {
      return this.errors.first(val);
    },
    isSuccess(val) {
      let ff = this.fields[val];
      return ff && ff.required && ff.valid;
    },
    getUserName() {
      if (this.isPersonal) {
        return `${this.onboardingStepData.user.personal.first_name} ${this.onboardingStepData.user.personal.second_name} ${this.onboardingStepData.user.personal.last_name_1} ${this.onboardingStepData.user.personal.last_name_2}`;
      } else {
        return this.onboardingStepData.user.business.name;
      }
    },
  },
}
</script>

<style>
  ul.check-ul {
    list-style: none;
    line-height: 35px;
  }

    ul.check-ul li:before {
        content: '✓';
        color: #28DE18;
        margin-right: 12px;
    }
</style>    